export enum TransactionsTypes {
    Repayment = 'Repayment',
    Disbursement = 'Disbursement',
    AdvancePayment = 'Advance payment',
}
